import { FC, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { urlParams } from '@lhb/func';
import { getShareContent, tenantCheck } from '@/common/api/common';
import { getModelClusterShareOverView, getModelClusterShareDetail, areaOverview } from '@/common/api/siteselectionmap';
import styles from './entry.module.less';
import SkeletonMapDetail from '@/common/components/Skeleton/SkeletonMapDetail';
import V2Container from '@/common/components/Data/V2Container';
import Top from './components/Top';
import Main from './components/Main';
import dayjs from 'dayjs';
import { setCookie } from '@lhb/cache';
import { getModelClusterDetail } from '@/common/api/networkplan';
import { UPDATE_TENANT_CHECK_INFO } from '@/store/common';
import { useDispatch } from 'react-redux';
import V2WaterMark from '@/common/components/Others/V2WaterMark';
import { getYouthMapDefaultConfig } from '@/common/api/youth';
import { changeShareDefaultConfig } from '../../store';

const Siteselectionmapb: FC<{}> = () => {
  const dispatch = useDispatch();
  const shareId = urlParams(location.search)?.shareId;
  const [shareParams, setShareParams] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true); // 加载中
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [overViewData, setOverViewData] = useState<any>(); // 概览数据
  const [waterText, setWaterText] = useState<string>('');
  useEffect(() => {
    shareId && methods.loadShareParams();
  }, [shareId]);

  // useEffect(() => {
  //   setStorage('IS_SHARE__HAS_TOEKN', true);
  // }, []);


  const methods = useMethods({
    /**
     * 加载分享参数
     * @deprecated 如果有修改这块逻辑，请更换使用 src/common/hook/useGetShareContent.ts，并修改 useGetShareContent 中的逻辑
     */
    loadShareParams: async () => {
      const params: any = {
        id: shareId
      };
      const res = await getShareContent(params);
      const { content } = res || {};
      const result = content ? JSON.parse(content) : {};
      setWaterText(result.waterText);
      if (!Object.keys(result)) return;
      const { failureTime, token } = result;
      if (dayjs().isAfter(failureTime)) {
        location.href = '/share/failure';
        return;
      }
      if (token) { // 服务端生成的临时token
        setCookie('flow_share_token', token);
        result && setShareParams(result);
        setTimeout(() => {
          methods.loadData(result);
        }, 100);
        return;
      }
      result && setShareParams(result);
      methods.loadData(result);
    },
    loadData: (params: any) => {
      setLoading(true);
      const _params = {
        id: params?.id,
        modelConfigId: params?.modelConfigId
      };
      Promise.all([
        params?.token ? getModelClusterDetail(_params) : getModelClusterShareDetail(_params),
        params?.token ? areaOverview(_params) : getModelClusterShareOverView(_params),
        params?.token ? tenantCheck() : undefined,
        // https://yapi.lanhanba.com/project/349/interface/api/88446
        getYouthMapDefaultConfig({ modelConfigId: params?.modelConfigId }),
      ]).then(([detailRes, overview, info, defaultConfig]) => {
        dispatch(changeShareDefaultConfig(defaultConfig));
        setDetail(detailRes);
        setOverViewData(overview);
        if (params?.token) {
          dispatch(UPDATE_TENANT_CHECK_INFO(info));
        }
      }).finally(() => {
        setLoading(false);
      });
    },
  });

  return (
    <>
      {/* 水印 */}
      <V2WaterMark show={!!waterText} content={waterText} />
      {loading
        ? <SkeletonMapDetail/>
        : <V2Container
          // 容器上下padding 0， 所以减去就是0
          style={{ height: '100vh' }}
          extraContent={{
            top: <Top
              detail={detail}
              overViewData={overViewData}
              shareParams={shareParams}
            />,
          }}
          className={styles.container}
        >
          <Main
            // viewChanceDetail={viewChanceDetail}
            // drawerData={drawerData}
            shareParams={shareParams}
            detail={detail}
            overViewData={overViewData}
            // historyVisible={historyVisible}
            // isMallType={isMallType}
            // modelConfigId={modelConfigId}
            // setHistoryVisible={setHistoryVisible}
            // showCreateDrawer={showCreateDrawer}
            // setShowCreateDrawer={setShowCreateDrawer}
            // getDetail={methods.getDetail}
            // pointDrawerData={pointDrawerData}
            // setPointDrawerData={setPointDrawerData}
            // configSwitch={configSwitch}
            // setGatherClientPoint={setGatherClientPoint}
            // gatherList={gatherList}
            // gatherClientLegendList={gatherClientPoint?.legendList}
          />
        </V2Container>
      }
    </>
  );
};

export default Siteselectionmapb;
